import React, { useState, useRef, useCallback, useEffect } from "react";
import { TextField, SortMenu } from "@ann/web-components";
import {
  FiltersContainer,
  FiltersLeftContent,
  FiltersRightContent,
} from "./Filters.styled";

const Filters = ({
  onSortChange,
  onOrderChange,
  selectedSortOption = "created_at",
  orderDirection = "desc",
  onSearchChange,
  loading = false,
}) => {
  const [searchValue, setSearchValue] = useState("");
  const searchTimeoutRef = useRef(null);

  const handleSearchChange = useCallback((value) => {
    setSearchValue(value);
    
    // Clear existing timeout
    if (searchTimeoutRef.current) {
      clearTimeout(searchTimeoutRef.current);
    }
    
    // Set new timeout for 500ms debounce
    searchTimeoutRef.current = setTimeout(() => {
      onSearchChange?.(value);
    }, 500);
  }, [onSearchChange]);

  // Cleanup timeout on unmount
  useEffect(() => {
    return () => {
      if (searchTimeoutRef.current) {
        clearTimeout(searchTimeoutRef.current);
      }
    };
  }, []);

  return (
    <FiltersContainer>
      <FiltersLeftContent>
        <TextField
          iconLeft="search"
          onChange={handleSearchChange}
          size="small"
          placeholder="Search"
          value={searchValue}
          disabled={loading}
        />
      </FiltersLeftContent>

      <FiltersRightContent>
        <SortMenu
          minWidth="200px"
          onChange={onSortChange || (() => {})}
          order={orderDirection.toLowerCase()}
          onOrderChange={onOrderChange || (() => {})}
          options={[
            {
              icon: 'clock',
              id: 'created_at',
              label: 'Most Recent'
            },
            {
              icon: 'sortByAlpha',
              id: 'name',
              label: 'Name (A-Z)'
            },
            {
              icon: 'update',
              id: 'updated_at',
              label: 'Last Updated'
            }
            // TODO: Uncomment when backend supports sorting by contact_name
            // {
            //   icon: 'sortByAlpha',
            //   id: 'contact_name',
            //   label: 'Contact Name (A-Z)'
            // }
          ]}
          selected={selectedSortOption}
          size="medium"
          title="SORT BY"
          width="240px"
          disabled={loading}
        />
      </FiltersRightContent>
    </FiltersContainer>
  );
};

export default Filters;

